import { CustomTheme, themes } from '@masfront/common-b2c'

import { makeStyles, createStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'

import { Brand, getBrandFromThemeName } from '~/brand'
import { deepMerge } from '~/utils'

const commonStyles = {
  root: {},
}

const styles = {
  [Brand.masmovil]: deepMerge(commonStyles, {
    root: {
      background: themes.masmovil.palette.primary.light,
      border: `1px solid ${themes.masmovil.palette.primary.light}`,
    },
  }),
  [Brand.llamaya]: deepMerge(commonStyles, {
    root: {
      background: '#F7E9F9',
      border: `1px solid ${fade(themes.llamaya.palette.primary.light, 0.6)}`,
    },
  }),
}

const useStyles = makeStyles((theme: CustomTheme) => {
  const stylesRules = styles[getBrandFromThemeName(theme.name)]

  return createStyles(stylesRules)
})

export default useStyles
